// 繁體多語言
const zh_tw = {
    _code: "編碼",
    _name: "名稱",
    _cost: "成本",
    _member: "會員",
    _vendor: "供應商",
    _inventory: "庫存",
    _discount: "折扣",
    _user: "使用者",
    _shop_and_station: "分店/工作站",
    _base_setup: "基本設定",
    _wechat_report_manager: "微信客戶報表管理",
    _wechat_report_auth: "微信報表授權管理",
    _user_maintenance: "使用者維護",
    _search: "搜尋",
    _reset: "重置",
    _edit: "修改",
    _askdelete: "是否刪除資料 ?",
    _delete_ok: "刪除成功",
    _exit: "退出",
    _save: "儲存",
    _delete_fail: "刪除資料失敗",
    _connect_hq_failed: "連接HQ失敗",
    _not_allow_empty: "不允許為空",
    _connecting: "正在連接服務器，請稍候...",
    _plesase_wait: "請稍候",
    _login: "登錄",
    _password: "密碼",
    _user_name: "用戶名",
    _login_password_error: "密碼錯誤",
    _connect_database_failed: "連接資料庫失敗",
    _select_please: "請選擇",
    _void_by: "取消者",
    _edit_by: "修改者",
    _create_by: "建立者",
    _void_date: "取消日",
    _edit_date: "修改日",
    _create_date: "建立日",
    _role_list: "角色列表",
    _recall: "恢復",
    _back: "返回",
    _super_admin: "超級管理員",
    _errtitle: "系統錯誤",
    _btn_close: "關閉",
    _err_code: "錯誤代碼",
    _err_message: "錯誤信息",
    _err_prog: "錯誤程序",
    _cfm_title: "確認提示框",
    _cfm_msg: "是否要繼續",
    _cfm_btnyes: "確定",
    _yes_msg: "操作成功！",
    _err_prog_msg: "程序發生錯誤，請與供應商聯繫",
    _dele: "刪除",
    _role: "角色",
    _current_user: "當前使用者",
    _success: "成功",
    _failure: "失敗",
    _home_page: "首頁",
    _navigation_menu: "導航菜單",
    _lbl_lock: "鎖定欄",
    _chk_show_deleted: "顯示已刪除資料",
    _username: "使用者名稱",
    _user_password: "使用者登入密碼",
    _show_all_menu: "顯示所有菜單",
    _show_authorized_menu: "僅顯示有權限的菜單",
    _reprot_menu_option: "報表菜單選項",
    _search_other_shop: "查詢其它分店",
    _confirm_cardno: "確認磁卡密碼",
    _comfirm_password: "確認使用者密碼",
    _full_name: "用戶全名",
    _user_role: "使用者角色",
    _language: "使用語言",
    _max_discount_rate: "最高折扣率",
    _salesman: "營業員",
    _cardno: "磁卡編碼",
    _auto_exit: "完成後自動退出",
    _hq: "HQ",
    _fore_sales: "前檯銷售",
    _report_center: "報表中心",
    _shop: "分店",
    _askrecall: "是否恢復資料？",
    _recall_success: "恢復成功",
    _suspend: "暫停使用",
    _addr: "地址",
    _district: "地區",
    _country: "國家",
    _shopgroup: "分店組群",
    _tel: "電話",
    _fax: "傳真",
    _contactperson: "聯絡人",
    _switch_tn: "可替其他分店開[轉倉單]",
    _switch_ii: "可替其他分店開[購貨單]",
    _switch_ord: "可替其他分店開[訂貨]",
    _switch_adj: "可更改其他分店庫存數量",
    _switch_sto: "可替其他分店做盤點",
    _instant_sales: "即時營業額",
    _dummy_shop: "假分店",
    _delivery_time: "發貨時間",
    _monday: "星期一",
    _tuesday: "星期二",
    _thursday: "星期四",
    _friday: "星期五",
    _saturday: "星期六",
    _sunday: "星期日",
    _holiday: "公眾假期",
    _wednesday: "星期三",
    _allow: "允許",
    _execute: "執行",
    _export: "匯出",
    _import: "匯入",
    _print: "列印",
    _email: "電郵",
    _commit: "審核",
    _edit_not_allow: "不能修改已刪除資料",
    _operating_time: "操作時間",
    _operating_type: "操作類型",
    _old_data: "舊數據",
    _new_data: "新數據",
    _field_name: "字段名稱",
    _loading_old_data: "加載舊數據",
    _role_access: "角色權限",
    _view: "查看",
    _content: "內容",
    _fr_inv: "新增發票",
    _view_historical_records: "查看歷史記錄",
    _exit_system: "退出系統",
    _do_not_input_same_code: "不能輸入重復的編碼",
    _role_no_access: "該用戶無此權限!",
    _verify_password_err: "密碼/卡號錯誤!",
    _access_validate: "權限驗證",
    _access_authorize: "授權",
    _yes: "是",
    _no: "否",
    _not_found: "找不到資料",
    _user_type: "使用者類型",
    _copy: "複製",
    _role_copy: "角色複製",
    _to: "至",
    _limit: "限制",
    _check_role: "以下角色輸入有誤，請檢查！",
    _win_title: "保雅電腦-Rms8",
    _template: "樣板",
    _ip_limit: "IP限制,你不能在此檯電腦登入系統.",
    _qty: "數量",
    _repeat: "重復",
    _format_error: "格式錯誤",
    _select_all: "全選",
    _add_tips: "點擊添加新的標籤頁",
    _user_info: "使用者信息",
    _login_count: "登入次數",
    _pre_login_time: "上次登入時間",
    _pre_lout_time: "上次登出時間",
    _login_info: "登入信息",
    _user_detail_info: "使用者詳細信息",
    _change_pwd: "修改密碼",
    _delete_not_allow: "刪除被拒絕",
    _dl_plugin: "點擊下載插件",
    _role_delete: "刪除失敗，該角色下包含有用戶",
    _old_pwd: "舊密碼",
    _new_pwd: "新密碼",
    _confirm_new_pwd: "確認新密碼",
    _login_time: "登入時間",
    _sys_setup: "系統設置",
    __coupen_need_open: "禮券 需要獨立支付的按鈕",
    _coupen_need_open: "禮券 需要獨立支付的按鈕",
    _station_function: "工作站功能",
    _station_hardware: "工作站硬件",
    _userinfo: "會員資料",
    _station: "工作站",
    _mac_address: "MAC地址",
    _report_xr_cross: "用戶列表",
    _uom: "量度單位",
    _station_name: "工作站名稱",
    _unit: "單位",
    _per: "每",
    _save_success: "儲存成功！",
    _business_section: "營業時段",
    _section: "時段",
    _rollback: "還原",
    _shop_list: "分店列表",
    _no_of_period: "時段數量",
    _cancel: "取消",
    _has_save_setting: "已成功存儲設置",
    _save_system_seting_failed: "設置項保存失敗",
    _has_copy: "已複製",
    _copy_success: "複製成功",
    _copy_Failed: "複製失败",
    _percentage: "百分比",
    _lookup: "一般設置",
    _pk_not_found: "沒有找到主鍵",
    _operation: "操作",
    _normal_credit_card: "普通信用卡",
    _cup: "銀聯",
    _quick_pass_macau: "快速支付(澳門)",
    _vendor_maintenance: "供應商維護",
    _payway: "付款方式",
    _d_add: "送貨地址",
    _salute: "稱呼",
    _effective_section: "生效營業時段",
    _chk_using: "是否使用",
    _using: "使用中",
    _mustinput: "必填",
    _start_time: "開始時間",
    _end_time: "結束時間",
    _include_shop: "包括分店",
    _exclude_shop: "不包括分店",
    _payway_type: "付款方式類型",
    _ecr: "附加費",
    _pay_days: "付款期限",
    _cur_sign: "貨幣單位",
    _open_drawer: "打開錢箱",
    _no_decimal_places: "沒有小數位",
    _input_cardno: "輸入卡號",
    _additional_fee_type: "附加費類型",
    _additional_fee_rate: "附加費率",
    _sales_type: "銷售類型",
    _traditional: "繁體",
    _simplified: "簡體",
    _item_cn: "中文點菜",
    _item_en: "英文點菜",
    _inv_cn: "簡體中文發票",
    _inv_en: "英文發票",
    _sitem: "套餐",
    _recipe: "材料",
    _item_pole_display: "顧客顯示屏",
    _new_item_as: "新增貨品作為",
    _kitchen_order: "廚房單",
    _days: "月結日",
    _currency_rate: "貨幣率",
    _ecr_id: "ECR刷卡機",
    _ecr_detail_sub_id: "ECR付款方式",
    _catery: "種類",
    _subcate: "子類",
    _brand: "品牌",
    _outlet_color: "營業區域顏色",
    _pplcnt: "餐廳預設人數",
    _tax: "稅項",
    _askppl: "是否需要問人數",
    _auto_disc: "是否允許自動折扣",
    _level_disc_add: "優惠組合加價",
    _no_using: "不使用",
    _custom: "自定義",
    _order: "點菜",
    _chinese: "中文",
    _english: "英文",
    _print_maintenance: "印表機維護",
    _dishes_cate: "菜式種類",
    _exit_to_system: "確定退出嗎 ?",
    _printer_name: "印表機名稱",
    _printer_backup: "後備列印機",
    _printer_group: "同組列印機",
    _ask_exit_system: "是否確定退出系統",
    _printer: "印表機",
    _to_printer_name: "轉向印機表",
    _print_mode: "菜式列印模式",
    _split: "分拆數量",
    _outlet: "營業區域",
    _diff_print: "請選擇不同的印表機",
    item_is_using_not_delete: "貨品正在使用,不能刪除",
    _each_dish_type: "每款菜式一張",
    _each_piece_of_food: "每件菜式一張",
    _type: "類型",
    _clear_one: "清除一個",
    _clear_all: "清除所有",
    _menu_dishe_cate: "餐牌菜式種類",
    _show_history_holiday: "顯示歷史公眾假期",
    _holiday_to: "公眾假期 由",
    _next_step: "下一步",
    _year: "年",
    _back_step: "上一步",
    _album_maintenance: "相冊維護",
    _album: "相冊",
    _current_position: "當前位置",
    _replace: "替換",
    _upload_success: "上傳成功",
    _list: "列表",
    _image: "圖片",
    _system: "系統",
    _upload_fail: "上傳失敗",
    _will_also_delete_the_pictures_in_the_album: "將會同時刪除該相冊中的圖片",
    _exist_continue: "已經存在,是否繼續",
    _item_transfer: "轉倉",
    _date_from: "日期 由",
    _date_to: "日期 至",
    _shop_from: "分店 由",
    _shop_to: "分店 至",
    _doc_adj: "更改存貨數量",
    _transfer_note: "轉倉單",
    _from_shop: "由分店",
    _to_shop: "至分店",
    _date: "日期",
    _reason: "原因",
    _committed_date: "審核日期",
    _item_code: "貨品編號",
    _item_name: "貨品名稱",
    _amount: "金額",
    _exist_qty: "現有數量",
    _copy_and_new: "復制和新建",
    _belong_date: "所屬日期",
    _warning: "警告",
    _dishes_setup: "菜式設定",
    _dishes: "菜式",
    _item: "貨品",
    _file_code: "文件編號",
    _item_not_found: "找不到貨品",
    _start_time_cost: "開始時成本",
    _the_net_cost: "最後入賬成本",
    _final_entry_cost: "最後入貨成本",
    _by_min: "按最小",
    _lowest: "最低",
    _order_qty: "定貨數量",
    _total: "合計",
    _already_exists: "已存在",
    _not_enough: "不足",
    _item_transfer_reason: "轉倉原因",
    _doc_adj_reason: "更改存貨數量原因",
    _network_error: "網絡錯誤",
    _please_contact_administrator: "請聯系管理員",
    _detailed_information: "詳細信息",
    _price: "售價",
    _only_for_following_login: "僅限以下{0}登入",
    _please_input: "請輸入",
    _purchase_order: "購貨單",
    _time_manage: "時間管理",
    _active: "生效",
    _daily: "每日",
    _weekly: "每周",
    _monthly: "每月",
    _reverse_selection: "反選",
    _value: "值",
    _effective_date: "生效日期",
    _expiring_date: "到期日期",
    _time: "時間",
    _advanced_setting: "高級設定",
    _expand: "展開",
    _collapse: "折疊",
    _all: "全部",
    _special: "特別",
    _adaptation: "適配",
    _group: "組群",
    _total_amount: "總金額",
    _shop_code: "店鋪編號",
    _vendor_code: "供應商編號",
    _vendor_name: "供應商名稱",
    _join: "加入",
    _current: "當前",
    _new: "新增",
    _add: "添加",
    _multi_select_dishes: "多選菜式",
    _other_options: "其他選項",
    _copy_to_another_name: "複製到其他名稱",
    _link_ppl: "和人數關聯",
    _show_in_order: "點菜時顯示",
    _multi_choise: "多選",
    _show_in_report: "於報表中分析",
    _multi_qty: "是否乘以數量",
    _cust_modi: "自定特別處理",
    _top_dispord: "點菜時顯示於頂層",
    _ppl: "人數",
    _special_price: "特別處理改價金額",
    _special_percentage: "特別處理改價百分比",
    _ordinary_special_treatment: "普通特別處理",
    _ask_for_special_treatment: "問動作特別處理",
    _desc_kit: "其他語言",
    _modi_cate: "種類中的特別處理",
    _Ingredients_increase: "配料處理加價",
    _sort: "排序",
    _modifier: "特別處理",
    _dishes_level: "菜式級別",
    _disc_cate: "折扣種類",
    _color: "顏色",
    _min_amt: "消費金額滿",
    _duty_free: "免稅項",
    _effective_time: "有效時間",
    _time_type: "時間類型",
    _ascending: "升序",
    _descending: "降序",
    _disc_dishes_level: "有效菜色級別",
    _disc_sys_user: "生效用戶",
    _level_combination: "級別 (A) + 級別 (B) --> 菜式級別 (B) 價格",
    _item_level_rule: "菜式級別規則",
    _a_item_level_id: "菜式級別 (A)",
    _b_item_level_id: "菜式級別 (B)",
    _rule_type: "規則類型",
    _a_and_b: "在A和B同時在生效時間內點餐適用",
    _a_or_b: "A或B 其中一個在生效時間內點餐適用",
    _suspended: "停用",
    _must: "必須",
    _general: "一般設定",
    _to_the_top: "至頂",
    _to_the_bottom: "至底",
    _callup: "叫起",
    _keyboard: "鍵盤",
    _remin: "追單",
    _print_inv: "列印發票",
    _table_no: "檯號",
    _invitem: "項目",
    _outstanding: "尚欠",
    _credit_card_no: "信用卡號碼",
    _sub_total: "小計",
    _rounding: "微調",
    _table_new: "新檯",
    _message: "信息",
    _line: "附加線",
    _generate_combo_package: "生成組合套餐",
    _xdisc: "組合優惠",
    _points_redemption: "會員積分換購",
    _sell_perqty: "可售賣數量",
    _modifier_soldout: "特別處理售罄",
    _delay_print: "延時列印",
    _enter: "進倉",
    _Warehouse: "出倉",
    _select_more: "選擇多個",
    _discount_list: "項目折扣列表",
    _history: "查看歷史操作",
    _today: "今天",
    _three_days_a: "前三天",
    _three_days_later: "后三天",
    _change_ppl: "更改人數",
    _member_disc: "會員折扣",
    _takeout_pickup: "外賣自取",
    _lock_and_unlock: "鎖定解鎖",
    _instant_cuisine: "即時菜式",
    _new_temp_table: "新增臨時餐檯",
    _view_carte: "查看已點菜式",
    _remove_temp_table: "刪除臨時檯",
    _associate_table: "關聯餐檯",
    _travel_amt: "營業額",
    _book_table: "餐檯預定",
    _sales_amount: "營業資料",
    _dishes_order_color: "菜式顏色及次序",
    _display_mode: "切換展示模式",
    _formmodicolor: "特別處理顯示次序及顏色",
    _check_turn_table: "查看轉檯情況",
    _service_charge_setup: "服務費設定",
    _print_eng_dish_paper: "列印英文上菜紙",
    _coupon: "優惠券",
    _modifier_setup: "特別處理設定",
    _seafood_brand: "海鮮牌",
    _check_warehoused: "項目進倉查詢",
    _dishes_inventory: "菜色與庫存",
    _prepare_checkout: "準備結賬",
    _relogin: "重新登錄",
    _main_window: "進入主頁",
    _area: "區域",
    _sub_area: "分區",
    _save_message: "存儲信息",
    _show_all: "顯示所有",
    _are_you_sure: "你確定要存儲嗎？",
    _delete_area: "是否刪除區域及相關數據",
    _delete_sub_area: "是否刪除分區及相關數據",
    _printer_no: "列印機編碼",
    _printer_node: "列印機節點",
    _default_printer_id: "默認打印機號",
    _file_type: "文件類型",
    _status: "狀態",
    _print_date: "列印時間",
    _threed_run: "線程是否運行",
    _TRACE_NOT_FOUND: "交易未找到",
    _setting_new_table_button: "結賬是否顯示新檯按鈕",
    _trace_fail: "交易失敗",
    _wait_trace: "等待交易",
    _transaction_completion: "交易完成",
    _terminal_busy: "終端繁忙",
    _local_currency: "本地貨幣符號",
    _setting_order: "點菜設定",
    _setting_oncall_ask_qty: "即起是否問數量",
    _or: "或",
    _reverse: "相反選擇",
    _show_checked_only: "只顯示已選擇項目",
    _available_modifier_list: "可選擇的特別處理列表",
    _selected_modifier_list: "已選擇的特別處理列表",
    _use_range: "使用範圍",
    _min_currency_unit: "最小貨幣單位",
    _more: "更多",
    _sale: "銷售",
    _purchase: "購貨",
    _payway_detail: "付款信息",
    _department: "部門",
    _background: "背景",
    _table: "檯面",
    _restaurant: "餐廳",
    _printer_setup: "列印設定",
    _order_outlet: "落單營業區域",
    _change_printer_area: "落單區域列印轉向設定",
    _can_not_repeat: "不可以重复",
    _are_you_sure_to_delete: "你要刪除該{0}嗎 ?",
    _rule: "規則",
    _dishes_modifier: "菜式處理",
    _check_time: "檢查次數",
    _select: "选择",
    _department_breakdown: "部門分帳",
    _function: "功能表",
    _split_table: "分檯",
    _pay: "結賬",
    _change_table: "轉檯",
    _order_slip: "上菜單",
    _split_order: "分單",
    _take_away: "外賣",
    _menu: "餐牌",
    _one: "選一個",
    _change: "找回",
    _missing: "補單",
    _send_order: "送單",
    _invoice: "發票",
    _period_all: "所有菜式一張",
    _sold_out_message: "售罄項目",
    _show_void_item: "查看刪除菜單",
    _item_discount: "項目折扣",
    _cancel_group_discount: "取消時段組合套餐",
    _svr_charge: "服務費",
    _printer_forward_setup: "轉向印表機設定",
    _srv_free: "免服務費",
    _input_soldout_msg: "輸入售罄信息",
    _change_dept_price: "更改部門分賬",
    _discount_entire_receipt: "整單折扣",
    _invoiceno: "發票編碼",
    _tips: "小費",
    _invoice_amt: "應付",
    _itemno: "編號",
    _item_desc: "菜式名稱",
    _order_time: "點菜時間",
    _wait_time: "等待時間",
    _waiter: "服務員",
    _callqty: "即起數量",
    _are_you_sure_changetable: "你確定要轉台嗎？",
    _last_setting_name: "最新設置",
    _allow_to: "是否允許{0}",
    _handwriting_item: "手寫項目",
    _required_item: "必須項目",
    _check_when_receipt_printed: "於印單時檢查",
    _times_no_of_guests: "是否乘人數(如茶資)",
    _ask_qty: "須詢問數量",
    _ask_price: "須詢問價格",
    _default_hold: "預設等叫起",
    _apply_dayend_analysis: "日結時分析",
    _include_in_min_charge: "是否計入最低消費",
    _custom_item: "自選項目",
    _keep_name: "保留名稱",
    _no_print_invoice_when_zero: "零金額不允許印發票",
    _can_do: "許可",
    _select_print_area: "選擇列印區域",
    _correct: "更正",
    _blank_key: "空白鍵",
    _upper: "大寫",
    _lower: "小寫",
    _dishes_print_is_refused: "以下菜式金額為零不允許打印",
    _is_defa: "會員預設類型",
    _price_lv: "會員價錢級別",
    _allow_all_pb: "所有價目表",
    _allow_all_mm: "所有優惠組合",
    _birth_add_points: "生日送積分",
    _amt_ceiling: " 金額上限",
    _perc: "正價貨折扣",
    _perc_disc_item: "特價貨折扣",
    _member_type: "會員類型",
    _cannot_change_empty_table: "尚未入座,不能轉台",
    _duplicate_disCount: "已存在相同的折扣,是否繼續？",
    _expiry_time: "失效",
    _item_cannot_discounted: "該項目不允許折扣！",
    _cln_type: "清機類型",
    _by_station: "按站點",
    _by_user: "按用戶",
    _receipt_printer: "印單列印機",
    _exception: "例外",
    _select_void_reason: "請選擇取消原因",
    _are_you_sure_delete: "你要刪除選擇的菜式？",
    _remain_qty: "剩餘數量",
    _qty_per_section: "每更可售賣數量",
    _warning_qty: "警告庫存數量",
    _is_limit_sell: "是否限量售賣",
    _calculate_by_kilo: "按斤計算",
    _calculate_by_hectogram: "按百克計算",
    _total_item_net_amount: "項目折實金額",
    _netamt: "實收金額",
    _no_record_will_be_save: "沒有資料是不能儲存的",
    _octopus_put_card: "請拍八達通",
    _octopus_rw_100021: "此八達通卡或貨品已失效，請聯絡港鐵客務中心",
    _octopus_rw_100022_l1: "+++ 請勿取消交易 +++",
    _octopus_file_gen: "建立八達通檔案成功 !!",
    _octopus_init_100001: "未能接駁八達通收費器",
    _octopus_init_100005: "未能接駁八達通收費器",
    _octopus_init_100101: "Failed to create AR(Save Log)",
    _octopus_init_100102: "Failed to create UD(Save Log)",
    _octopus_init_100099: "Firmware upgrade has performed due to HouseKeeping()",
    _octopus_rw_100001: "未能接駁八達通收費器",
    _octopus_rw_100005: "未能接駁八達通收費器",
    _octopus_rw_100016: "讀卡錯誤, 請重試",
    _octopus_rw_poll_100017: "讀卡錯誤, 請重試",
    _octopus_rw_deduct_100017: "讀卡錯誤, 請重試",
    _octopus_rw_100017: "讀卡錯誤, 請重試",
    _octopus_rw_100034: "讀卡錯誤, 請重試",
    _octopus_rw_100020: "請再拍卡",
    _octopus_rw_100022: "交易未完成, 請重試",
    _octopus_rw_100023: "Transaction Log full",
    _octopus_rw_100032: "請再拍卡",
    _octopus_rw_100048: "餘額不足",
    _octopus_rw_100049: "儲值額超出上限",
    _octopus_error: "發生錯誤(編號",
    _octopus_starting_please_wait: "八達通處理器正在啟動中, 請稍候 ... ... ...",
    _octopus_init_again_please_wait: "檢查八達通處理器, 請稍候 ... ... ...",
    _octopus_rw_100057: "零售限額已過",
    _octopus_rw_100025: "交易未完成, 請重試",
    _octopus_rw_100022_retry: "請重試(八達通號碼",
    _octopus_can_not_use_select_other_payment: "不能使用八達通, 請選用其他付款方法",
    _octopus_rw_same_card_retry: "錯卡, 請重試 ( 八達通卡編號",
    _octopus_re_connct_are_you_sure: "是否 重新檢查八達通處理器 ?",
    _octopus_it_may_take_1_or_2_minute: "可能需時 1- 2 分鐘",
    _octopus_card_adult: "成人",
    _octopus_card_student: "學生",
    _octopus_card_child: "小童",
    _octopus_card_elder: "長者",
    _octopus_card_personalized: "個人",
    _octopus_rw_100019: "此卡失效",
    _octopus_add_value_exceed_limited: "儲值額超出上限",
    _octopus_deduction_value_exceed_limited: "扣除金額超出上限",
    _octopus_rw_100024: "此卡失效",
    _octopus_rw_100051: "控制台識別號碼不正確",
    _octopus_add_value_can_not_void: "八達通增值, 不能刪除此發票",
    _octopus_add_value_can_not_edit: "八達通增值, 不能更改此發票",
    _octopus_change_to_cash: "刪除時會轉成 [ 現金 ]",
    _octopus_print_remain: "餘額",
    _octopus_print_cardno: "八達通卡號碼",
    _octopus_print_device: "機號",
    _octopus_print_payment: "八達通付款",
    _octopus_rw_100022_l2: "交易未能完成請通知顧客用同一張卡",
    _octopus_rw_100022_l3: "再次拍卡，以確保交易無誤",
    _time_comparison: "結束時間必須大於開始時間",
    _diff_time: "時間重疊",
    _not_found_file: "找不到檔案 !!",
    _database_name: "數據庫名稱",
    _cover: "位",
    _include_all_shop: "(* = 包括所有分店 )",
    _exclude_all_shop: "(* = 不包括所有分店 )",
    _price_level: "價錢級別",
    _level: "級別",
    _kit_order_print_ppl: "廚房單是否列印人數",
    _kit_print_item_amount: "廚房單是否列印金額",
    _kitchen_order_slip_content: "廚房單列印內容",
    _kit_print_order: "廚房單打印次序",
    _kit_modi_print_langue: "特別處理列印內容",
    _notify_kit_when_void_item: "取消菜式是否通知廚房",
    _notify_kit_when_move_table: "轉檯是否通知廚房",
    _print_to_kitchen: "是否列印廚房單",
    _kit_print_item_code: "廚房單是否列印菜式編號",
    _void_item_all_in_one: "取消菜式是否所有菜式一張單",
    _table_move_print_item: "整單轉檯是否列印菜式內容",
    _sitem_print_add_line: "套餐是否列印間線",
    _password_expiration_days: "密碼過期天數",
    _can_not_same_as_recent_use: "不能與您最近使用的相同",
    _expired: "過期",
    _password_rules: "密碼規則",
    _whether_freeze_password: "是否凍結密碼",
    _freezing_minutes: "凍結分鍾",
    _please_change_password: "請盡快修改密碼",
    _already_frozen_log_after: "已凍結,請{0}分鐘後再登錄",
    _cash_pay: "現金付款",
    _retry: "重試",
    _unselect_all: "全不選",
    _sell: "售賣",
    _octopus_com_port: "八達通連接埠",
    _setting_kit: "廚房單打印設定",
    _octopus_have_display: "八達通裝置有顯示銀碼",
    _octopus_baud_rate: "八達通連接速度",
    _octopus: "八達通",
    _setting_table_setup: "堂座模式",
    _table_flash_having_unfinish: "有未完成項目時餐檯是否閃動",
    _table_can_chg_diff_outlet: "不同區域是否允許轉檯",
    _direct_pay_mode: "是否直接付款",
    _octopus_loc_id: "八達通Location ID",
    _void_item_ask_reason: "取消菜式是否問原因",
    _change_price_after_printed: "已印至廚房是否允許更改價格",
    _can_sell_sellout_item: "售罄後是否允許繼續售賣",
    _click_item_red_flash: "點擊時是否使用紅框提示閃動",
    _modi_item_allow_neg: "菜式金額是否允許為負數",
    _crashier_auto_exit: "結帳自動退出時間(秒)",
    _crashier_preview_inv: "結帳是否預覽發票",
    _disc_srv: "服務費是否允許折扣",
    _table_show_big: "餐檯放大顯示比例",
    _copy_station: "複製站點",
    _input_sequence: "按入單次序",
    _previous_page: "上一頁",
    _group_by_item_order_by_amt: "編號加總再按金額排序(由大到小)",
    _next_page: "下一頁",
    _group_by_item_order_by_qty: "編號加總再按數量排序(由大到小)",
    _group_by_item_order_by_item: "編號加總再按編號排序(由大到小)",
    _void_reason: "取消原因",
    _entire_system: "整個系統",
    _outlet_mode: "營業區域模式",
    _cln_cash_in_reason: "清機收入原因",
    _cln_cash_out_reason: "清機支出原因",
    _kitchen: "廚房",
    _chinese_englisth: "中文+英文",
    _chinese_english_kitchen: "中文+英文+廚房",
    _other_langue: "其它語言",
    _chinese_other_langue: "中文+其它語言",
    _english_other_langue: "英文+其它語言",
    _kit_other_langue: "廚房+其它語言",
    _chinese_english_other_langue: "中文+英文+其他語言",
    _chinese_kitchen: "中文+廚房",
    _english_kitchen: "英文+廚房",
    _join_print_inv: "加入發票打印",
    _floor_plan_mode: "平面圖模式",
    _simple_mode: "簡單模式",
    _keyboard_input_qty: "鍵盤輸入時必須輸入數量",
    _about: "關於",
    _invoice_print_in_fastfood: "快餐是否印發票",
    _inv_qty_for_fastfood: "快餐發票打印張數",
    _fastfood_askno: "快餐人手輸入叫號",
    _fastfood_need_remark: "快餐是否需要輸入備注",
    _auto_askno_begin: "自動叫號開始編號",
    _auto_askno_end: "自動叫號結束編號",
    _fastfood_choose_outlet: "快餐模式是否可選擇營業區域",
    _fastfood_can_only_save: "快餐模式是否允許補單",
    _fastfood_split_print: "快餐模式是否有分單列印功能",
    _auto_askno_ab: "自動叫號是否選擇AB",
    _askno_auto_reset: "自動叫號是否每天RESET",
    _cashier: "收銀員",
    _invno: "發票號碼",
    _seattime: "入座時間",
    _amtperhead: "人均消費",
    _scriber: "簽署",
    _use: "用餐",
    _sit: "入座",
    _printed: "已打印",
    _clear: "清理中",
    _lock: "鎖定",
    _table_clearing: "餐檯仍在清理中",
    _continue_anyway: "是否繼續?",
    _is_require_qty: "是否詢問數量",
    _dedu_srv: "是否可對沖服務費",
    _fast_food_mode: "快餐模式",
    _inv_setup: "發票打印設定",
    _setting_email: "電郵設定",
    _pay_slip_setting: "埋腳紙打印設定",
    _paylist_print_ntime: "埋腳紙打印數量",
    _octoups_print_paylist: "八達通付款是否印埋腳紙",
    _print_slip_setting: "上菜紙列印設定",
    _print_slip: "是否列印上菜紙",
    _fastfood_print_slip: "快餐模式是否列印上菜紙",
    _turn_to_page: "轉入分頁",
    _page: "頁面",
    _maintenance: "維護",
    _manage: "管理",
    _tables: "桌面",
    _height: "高度",
    _width: "寬度",
    _foreColor: "前景色",
    _confirm: "確認",
    _upload: "上傳",
    _setup: "設置",
    _prompt: "提示",
    _remark: "備注",
    _file_does_not_exist: "文件不存在",
    _over_maximum_gust_amount: "人數超出限制",
    _receipt_printed: "餐檯已印單",
    _cannot_change_table: "不能轉台",
    _send_reminder: "你是否進行催單？",
    _step: "第{0}步",
    _from: "由",
    _change_table_coanot_be_undone: "轉台操作不可恢復",
    _cannot_change_be_diff_outlet: " 不同區域,不可轉台",
    _printed_cannot_continu: "已印單, 不允許再進行此操作！",
    _not_set: "未設定",
    _cateries: "分類",
    _remin_time: "追單時間",
    _paidtime: "結賬時間",
    _inv_print_addition_header: "發票是否列印銀碼紙",
    _print_perhead: "是否列印人均消費",
    _inv_print_itemcode: "發票是否列印菜式編號",
    _max_ppl: "餐檯最大人數",
    _inv_remark: "發票備註",
    _not_allow_zero: "輸入不能為零!",
    _printed_item_notallow_up_qty: "菜式已印單,數量只可改小,不可改大!",
    _cleaning_table_reset_time: "清理中的餐檯自動恢復正常時間(分",
    _disc_not_active: "折扣不生效,請檢查折扣設定.",
    _item_level_disc_disable: "折扣對此菜式的級別無效.",
    _pricebook: "價目表",
    _as_discount: "作為折扣",
    _data_already_exists: "數據已經存在",
    _fix_price_qty: "修改價格和數量",
    _default_item: "預設菜式",
    _have_no_right: "你沒有使用權限",
    _please_contact_with_admin: "請聯繫管理員",
    _askno_ppl: "叫號/人數",
    _askno: "叫號",
    _itemlist: "項目清單",
    _inv_amt: "發票金額",
    _paid_amt: "付款金額",
    _change_price: "轉價",
    _payment_slip: "付款清單",
    _dept_analyse: "部門分析",
    _reprint_inv_dntpay: "重印發票,請勿付款 !",
    _slip_printer: "上菜紙打印機",
    _inv_printer: "發票打印機",
    _station_setup: "工作站設置",
    _input_askno: "請輸入叫號",
    _input_remark: "請輸入備註",
    _copy_shop: "複製分店",
    _email_smtp: "SMTP",
    _email_user_password: "用戶密碼",
    _email_port: "電郵端口",
    _email_method: "發送電郵程序",
    _email_co: "電郵上的寄件者名稱",
    _email_format: "附件格式",
    _email_user_name: "用戶名稱",
    _print_pay_slip: "是否列印埋腳紙",
    _modifier_list: "特別處理列表",
    _is_allow_tips: "是否允許小費",
    _exchange: "對換數",
    _outletsrv: "是否按區域收取服務費",
    _tick_will_be_added_to_dishes_in_menu: "打√, 將會在餐牌下對應的菜式種類中加入當前菜式; 取消√, 將會刪除當前菜式在餐牌下對應的菜式種類中的所有價格",
    _all_time: "全部時間",
    _click_delete_will_remove_menu_under_dishes: "點擊刪除, 將會刪除當前餐牌對應菜式種類下的對應菜式",
    _tick_will_add_dishes_cate_in_menu: "打√, 將會在餐牌中加入當前菜式種類, 取消√, 將會在餐牌中刪除當前菜式種類; 點擊添加菜式, 將會在餐牌下當前菜式種類中加入菜式; 點擊刪除, 將會刪除餐牌下當前菜式種類中的對應菜式.",
    _tick_on_the_appropriate_line: "請在相應行打√",
    _differ_time: "時間差",
    _voidtime: "取消時間",
    _tables_information_management: "桌面信息管理",
    _select_background_image: "選擇背景圖片",
    _background_image: "背景圖片",
    _system_image: "系統圖片",
    _custom_image: "自定義圖片",
    _upload_imagge: "上傳圖片",
    _self_order: "自助點餐",
    _please_input_item_code: "請輸入顯目編號",
    _search_by_itemno: "搜索編號",
    _set_table: "設置餐桌",
    _undecided_dishes: "未定菜式",
    _please_input_qty: "請輸入數量",
    _no_found: "沒有找到",
    _delete_octopus_tips: "不允許刪除八達通",
    _please_select_menu: "請選擇餐牌,并按確定按鈕",
    _this_table_is_locked: "該桌檯正在點餐,無法進入",
    _has_been_sold_out_cannot_order: "已售罄,不可以點餐",
    _has_been_sold_out_can_order: "已售罄,可以點餐 ",
    _select_target_table: "請選擇目標餐桌",
    _send_order_success: "送單成功",
    _tables_can_chg_after_print: "印單後是否允許轉檯",
    _direct_pay_show_inv: "直接付款是否顯示發票",
    _hide_main_table: "分檯界面是否隱藏主檯(為空時)",
    _sit_overtime: "入座多少分鐘後開始提示",
    _sit_deadtime: "入座多少分鐘後開始大提示",
    _content_repeat_re_input: "輸入內容重復,請重新輸入",
    _active_time: "生效時間",
    _re_play: "落單",
    _select_please_color: "請選擇顏色",
    _checked_table: "選檯",
    _dishes_code: "菜式編碼",
    _can_only_choose_one: "只能選擇其中一項",
    _custom_color: "自定義顏色",
    _apply_custom_color: "採用自定義顏色",
    _copy_color_to_items_with_same_catery: "把顏色拷貝至同一種類",
    _change_no: "更改人數",
    _insert_blank: "插入空行",
    _remove_blank: "刪除空行",
    _effective_section_must_cover_24_hours: "營業時段必須覆蓋24小時",
    _all_cash: "全數現金",
    _card_no: "卡號",
    _should_change: "應找回",
    _tables_pplcnt_notallow_zero: "已點菜,人數不能改為零 !",
    _auto_number: "自動編號",
    _all_shop: "全部分店",
    _please_correct_the_pay_amount: "請更正付款金額",
    _please_input_amount: "請輸入金額",
    _please_input_change: "請輸入找回",
    _cannot_further_split_table: "已是子檯,不可以再分檯",
    _please_input_no: "請輸入人數",
    _please_input_cutom_discount_amount: "請輸入自定義折扣金額",
    _please_input_price_per_unit: "請輸入價格",
    _cannot_increase_qty: "菜式已印單,數量只可改小不可改大",
    _item_show_descen: "菜式項目是否同時顯示中英文名稱",
    _item_colsint: "菜式顯示列間隔",
    _modi_large_gui: "特別處理加大顯示界面",
    _item_lines: "菜式項目顯示行數",
    _item_cols: "菜式項目顯示列數",
    _modi_fontsize: "特別處理字體大小",
    _modi_panel_backcolor: "特別處理界面背景顏色",
    _cate_fontsize: "菜式種類字體大小",
    _cate_panel_backcolor: "菜式種類背景顏色",
    _cate_lines: "菜式種類顯示行數",
    _orderlist_backcolor: "點菜界面背景顏色",
    _item_selected_color: "點菜選定顏色",
    _order_lines: "點菜界面行數",
    _modi_lines: "特別處理顯示行數",
    _modi_cols: "特別處理顯示列數",
    _modi_lineint: "特別處理顯示行間隔",
    _modi_colsint: "特別處理顯示列間隔",
    _cate_lineint: "菜式種類行間隔",
    _cate_colsint: "菜式種類顯示列間隔",
    _order_lineint: "點菜界面行間隔",
    _disp_item_id: "點菜時是否顯示菜式編號",
    _cate_cols: "菜式種類顯示列數",
    _item_fontsize: "菜式項目字體大小",
    _item_panel_backcolor: "菜色項目背景顏色",
    _order_item_fontsize: "落單菜式字體大小",
    _item_lineint: "菜式顯示行間隔",
    _color_setup: "界面設定",
    _modifier_color_setup: "特別處理顏色及次序",
    _brow_level_item: "查看當前級別的菜式",
    _please_select_printer_language: "請選擇打印機語言",
    _select_language: "選擇語言",
    _select_at_least_one: "至少選一個",
    _please_select_system_language: "請選擇系統語言",
    _table_setup: "餐檯設置",
    _local_report: "本地報表",
    _dishes_list: "菜式列表",
    _hide: "隱藏",
    _kit: "廚房單",
    _kit_cancel: "廚房取消單",
    _kit_remind: "廚房催單",
    _kit_take_away: "廚房外賣單",
    _kit_change_table: "廚房轉台單",
    _inv_dine_in: "發票(堂座)",
    _inv_take_away: "發票(外賣)",
    _pay_slip_dine_in: "埋腳紙(堂座)",
    _addition_header: "銀碼紙",
    _pay_slip_take_away: "埋腳紙(外賣)",
    _slip: "上菜紙",
    _report_sourece: "報表源",
    _dishes_combo: "菜式組合",
    _cannot_move_table_in_use: "不能移動使用中的檯",
    _tableno_not_found: "找不到檯號",
    _are_you_suret_remove_this_table: "你確定要刪除嗎",
    _add_new_page: "添加新頁",
    _fastfood_info: "快餐信息",
    _cln_report: "清機報表",
    _paid_analyse: "付款分析",
    _outlet_analyse: "區域分析",
    _item_analyse: "菜式分析",
    _section_analyse: "營業時段分析",
    _printed_item_move: "印單後轉檯菜式",
    _report_type: "報表類型",
    _invoice_list: "發票清單",
    _cln_no: "清機編號",
    _void_item: "取消菜式",
    _refresh_data: "刷新數據",
    _display_cancel_report: "顯示取消報表",
    _modify_invoice: "修改發票",
    _modify_pay_slip: "修改埋腳紙",
    _modify_table_slip: "修改上菜紙",
    _modify_kit: "修改廚房單",
    _modify_addition_header: "修改銀碼紙",
    _modify_cln_report: "修改清機報表",
    _select_report_file: "選擇報表文件",
    _times: "次數",
    _title: "標題",
    _send_email: "發送郵件",
    _email_to: "發送郵件",
    _email_cc: "郵件抄送",
    _no_srv_amt: "不含服務費金額",
    _end: "結束",
    _disc_analyse: "折扣分析",
    _orgamt: "原本金額",
    _expense_amount: "支出金額",
    _cash_amt: "實收現金",
    _inv_qty: "發票張數",
    _cust_qty: "顧客人數",
    _amtperorder: "平均每單消費",
    _discamt: "折扣金額",
    _total_tips: "小帳合計",
    _opening_cash: "銀頭",
    _spectra: "刷卡機",
    _cash_drawer: "錢箱",
    _cash_drawer_com_port: "錢箱連接埠",
    _cash_drawer_baud_rate: "錢箱連接速度",
    _is_visible: "是否可見",
    _cash_drawer_data_bits: "錢箱連接速度",
    _spectra_com_port: "刷卡機連接埠",
    _yes_no: "是/否",
    _invoice_info: "營業資料",
    _display_order: "顯示次序",
    _report_path_not_found: "報表路徑未找到",
    _reprint_report: "重印報表",
    _inv_printing: "列印發票細節",
    _dept_printing: "列印部門分析",
    _disc_after_inv: "印單後折扣",
    _sending_mail: "正在發送郵件,請稍等...",
    _inv_prined: "已列印發票",
    _calc_with_org_price: "以原價計",
    _calc_with_act_price: "以實價計",
    _title_length: "標題長度必須大於1",
    _date_range: "日期範圍",
    _cln_date: "清機日期",
    _cln_data: "清機數據",
    _closing_include: "清機包括",
    _cash_in: "現金收入",
    _edit_table: "編輯檯",
    _remove_table: "刪除檯",
    _opening_cash_detail: "銀頭明細",
    _move_table: "移動檯",
    _save_setting: "保存設置",
    _page_manage: "頁面管理",
    _set_backundimage: "設置背景圖片",
    _sales: "銷售",
    _report_daily: "日結報表",
    _invalid_date: "日期錯誤",
    _select_first: "請先選擇{0}",
    _edit_report: "修改報表",
    _same_lang: "名稱全部與{0}相同",
    _show_cashier: "付款分析時顯示收銀員（多餘一個小時）",
    _actual_price: "以實計價",
    _show_items_whith_price_zero: "打印當天價格更新記錄",
    _disc_after_print_inv: "印單后折扣",
    _hourly_sales_amount: "每小時營業額",
    _the_details_invoice_of_discount: "發票折扣細節",
    _item_set_price: "套餐菜式加價",
    _receipt_price_changed: "打印當天的價格更改記錄",
    _showitem_with_zero: "日結分析的菜式金額為零時是否顯示",
    _no_disc_points_card: "無折扣有積分會員卡",
    _modify_payment_slip: "修改付款清單",
    _modify_slip: "修改上菜紙",
    _modify_kitchen_order: "修改廚房單",
    _share_order: "分單",
    _call_item: "即起菜式",
    _check_choiced_item: "查看已點菜式",
    _ask_discount_reason: "折扣是否問原因",
    _table_add_cleaning_status: "結賬後加入清理狀態",
    _disc_reason: "折扣原因",
    _order_ingredient_option: "請選擇動作！",
    _select_modifier: "選擇特別處理",
    _table_no_order_nochange: "該餐檯未點菜,不允許轉檯.",
    _table_nouse_nochange: "尚未入座，不能轉檯 !",
    _input_qty: "請輸入折扣數量",
    _min_charge: "最低消費差額",
    _invinfo_show_amt: "營業資料是否是顯示總金額",
    _do_clean_table_must_empty: "必須清空所有餐檯才能清機",
    _print_itemlist_in_pay_slip: "埋腳紙是否列印菜式",
    _slip_print_adduser_time: "埋腳紙是否列印落單人及時間",
    _paylist_print_table_name: "埋腳紙是否印餐檯名稱",
    _paylist_print_inv_header: "埋腳紙是否列印發票頭備注",
    _pay_slip_print_disc: "埋腳紙是否打印折扣",
    _round_to_dollar: "四捨五入到元",
    _round_to_10cents: "四捨五入到毫",
    _more_to_dollar: "多收至元",
    _less_to_dollar: "少收至元",
    _round_to_cents: "四捨五入到仙",
    _more_to_5cents: "多收至五仙",
    _less_to_5cents: "少收至五仙",
    _more_to_50cents: "多收至五毫",
    _less_to_50cents: "少收至五毫",
    _no_change: "不變",
    _input_call_num: "請輸入即起數量",
    _call_qty_larger_than_qty: "即起數量不能大於原數量",
    _allcall: "全部即起",
    _guests: "人數",
    _itemcode: "菜色編號",
    _cmd_ok: "確定 (\<O)",
    _table_booking: "餐檯預訂",
    _day_before: "前一天",
    _day_after: "後一天",
    _date_selection: "選擇日期",
    _current_date: "當天",
    _skip: "跳動",
    _table_clear: "清空檯",
    _table_notfound: "找不到檯號 !",
    _language_select: "選擇語言",
    _sys_message: "系統提示",
    _dayend: "日結",
    _clean_reprint: "重印清機單",
    _delete_invoice: "刪除發票",
    _reprint: "重印",
    _reset_qty: "重置數量",
    _invalid: "不生效",
    _backgrounf_image: "背景圖片",
    _square: "正方形",
    _seat_qty: "座位數量",
    _table_no_of: "餐檯數量",
    _per_table: "每檯",
    _per_head: "每人",
    _big_table_name: "餐檯名稱放大顯示",
    _cleaned: "已清機",
    _non_cleaned: "未清機",
    _datetype: "日期種類",
    _dayend_include: "日結報表包括",
    _preview: "預覽",
    _date_time: "日期時間",
    _octopus_no: "八達通卡號碼",
    _last_add_value_by_cash: "上一次於 {0} 現金增值",
    _if_you_have_any_queries_on_transaction: "客戶如對上述的八達通交易有任何查詢，請保存此存根及致電八達通顧客服務熱線 2266 2222。",
    _add_table_by_no: "快速新增檯號",
    _inv_void: "以下發票將被刪除,要繼續嗎 ?",
    _drink_qty: "配飲品數量",
    _level_cannot_same: "級別不能相同",
    _level_rule_error: "級別規則定義錯誤,不允許有交叉定義",
    _table_have_unfinish_item: "該餐檯有未完成的項目,不能印單 !",
    _invalid_char: "輸入字串含有不正確的符號, 請重新輸入",
    _change_price_no_level_disc: "更改價格後，不再有餐飲級別優惠，要繼續嗎？",
    _select_none: "全部清除",
    _allow_to_sell: "是否允許售賣",
    _dishes_price: "菜式售價",
    _copy_to: "複製到",
    _select_one: "選一個",
    _backspace: "後退鍵",
    _do_clean_table_must_unused: "必須清空所有餐檯才能清機 !!",
    _table_printed_nochange: "餐檯已印單,不能轉檯 !",
    _linkppl_modi_change_ppl_inside: "有人數關聯的特別處理，請在入單界面更改人數。",
    _sts_message: "系統提示",
    _enter_sale_info: "設定售罄信息",
    _input_code_or_plus: "輸入菜色編號 或 + 號更改數量",
    _cln: "清機",
    _ok: "確定",
    _waitor: "服務員",
    _void_time: "刪除時間",
    _table_notallow_lock: "已經有人入座，不能鎖定 !",
    _no_unlock_link_inv_table: "該餐檯關聯的主餐檯已印單，不允許解鎖.",
    _soldout_dishes: "售罄菜式",
    _item_split: "菜式分單",
    _share_order_done: "已作分單,如需要修改,請先刪除分單!",
    _order_split_not_finish: "分單操作未完成!",
    _table_is_locked: "餐檯已鎖定，請先解鎖。",
    _valid: "生效",
    _waiting_time: "等待時間",
    _nitem_onlysave_not_printed: "個項目只作保存不會列印到廚房,是否繼續？",
    _table_noorder_noslip: "該餐檯未有點菜,不能印上菜紙 !",
    _outlet_info_no_exist: "營業區域信息不存在，請先維護營業區域信息",
    _tables_page_not_exist: "餐檯分頁信息不存在,請先維護分頁。",
    _outlet_shop_not_exist: "分店營業區域不存在,終止點餐",
    _task_queue: "個任務排隊中",
    _order_func: "訂單功能表",
    _table_func: "餐檯功能表",
    _can_only_add_one_take_away: "外賣類型只能添加一個",
    _expiration_date_can_not_less_than_effective_date: "到期日期不能小於生效日期",
    _empty_section: "營業時段不能為空",
    _exclude_sitem: "套餐除外",
    _split_package_sub_item: "分拆套餐子項目",
    _sub_table_full: "最多只能分15張子檯",
    _delete_take_away_tips: "不允許刪除外賣類型",
    _cash_bf: "銀頭",
    _cash_out: "現金支出",
    _chkdept_printing: "列印部門分析",
    _chkhourly_sales_amount: "每小時營業額",
    _show_all_items: "所有菜式",
    _show_all_dishescate: "所有菜類",
    _receipt: "重印單",
    _other_receipt: "其他語言發票",
    _other_slip: "其他語言上菜紙",
    _copy_and_add: "複製添加",
    _include: "包括",
    _exclude: "不包括",
    _clear_input: "清除",
    _service_charge_multiple: "服務費倍數",
    _current_shop: "當前分店",
    _current_station: "當前工作站",
    _inv_chs: "簡體發票",
    _inv_cht: "繁體發票",
    _input: "輸入",
    _srv_charge: "服務費",
    _payment_slip_eng: "英文付款清單",
    _payment_slip_cht: "繁體付款清單",
    _payment_slip_chs: "簡體付款清單",
    _table_noorder_nopay: "尚未點菜,不允許結賬 !",
    _cancel_share_order: "取消分單",
    _select_discreason: "請選擇折扣原因",
    _disc_amount: "折扣金額",
    _unit_price: "單價",
    _unit_price_and_modi_amount: "單價+特別處理加價",
    _kit_item_amt_showtype: "廚房單列印金額內容",
    _default_printer: "默認印表機",
    _printer_paper_problem: "紙張有問題",
    _out_of_tonner: "碳粉用完了",
    _printer_not_available: "印表機不可用",
    _printer_out_of_memory: "內存出錯",
    _printer_paper_jam: "卡紙了",
    _printer_paused: "暫停中",
    _printer_low_on_toner: "碳粉不足夠",
    _printer_off_line: "離線狀態",
    _printer_error_state: "不明原因",
    _printer_user_intervention: "不明原因",
    _printer_full_output_bin: "超過列印隊列數量限制",
    _print_server_no_running: "Print Server 未啟動",
    _transfer_from: "轉由",
    _not_allow_mult_item_disc: "不允許同時對多個菜式進行項目折扣 !",
    _buildin_data_no_dele: "系統預設數據,不可刪除",
    _printer_out_of_paper: "紙張用完了",
    _printer_open_door: "印表機門未關",
    _inv_print_transfer_from: "發票是否列印轉由列印機",
    _pay_slip_print_transfer_from: "埋腳紙是否列印轉由列印機",
    _slip_print_transfer_from: "上菜紙是否列印轉由列印機",
    _copy_to_another_price_from_price1: "從售價1複製到其他售價",
    _item_print_mode_item_set: "套餐列印一張單",
    _slip_print_mode: "上菜紙列印方式",
    _print_all: "全部重新列印",
    _print_new_only: "只列印新增菜式",
    _print_first_only: "不列印新增菜式",
    _slip_print_Item_amount: "上菜紙是否列印金額",
    _slip_print_Item_code: "上菜紙是否印菜式編號",
    _slip_print_include_modifier: "上菜紙是否打印特別處理",
    _slip_print_adduser: "上菜紙是否印點菜人及時間",
    _slip_print_free_modifier: "上菜紙是否列印不加價的特別處理",
    _sitemsub_notallow_disc: "所選菜式不允許項目折扣 !",
    _call_up: "即起",
    _slip_change: "更改",
    _slip_new: "加單",
    _print_now: "立即列印",
    _order_ingredient_base: "你未選擇配料 !",
    _divided: "分檯",
    _hexadecimal: "十六進制",
    _decimal: "十進制",
    _uom_change_continue_save: "單位有變動,會影響計算方法,繼續保存嗎",
    _name_length_over_limited: "名稱長度超出限制",
    _kit_order_print_code: "廚房單是否列印編號",
    _order_entry_item_font_size: "點菜界面菜式字體大小",
    _order_entry_modifier_font_size: "點菜界面特別處理字體大小",
    _outlet_not_found: "營業區域資料找不到，請先添加營業區域 !",
    _show_table_position_by_setting: "是否按設置顯示桌檯位置",
    _order_must_item: "以下必須項目仍沒有落單",
    _table_is_locked_by: "餐檯已被{0}鎖定。",
    _refresh: "刷新",
    _foreign_currency: "外幣",
    _domestic_currency: "本國貨幣",
    _currency_type: "貨幣類型",
    _cash: "現金",
    _no_of_inv: "發票數量",
    _details: "詳細說明",
    _paidlist: "已結賬",
    _only_show_uncleaned: "(只顯示未清機金額)",
    _price_add: "售價加價",
    _price_breaks: "售價減價",
    _copy_to_another_price: "複製到其它售價",
    _paid_invoice: "已付款",
    _custom_code_repeat: "自定義編碼重復",
    _octopus_query: "八達通查詢",
    _item_available: "可使用菜式",
    _item_details: "菜式內容",
    _mincharge_diff: "最低消費差額",
    _minimum_rate_for_service_charge: "最低消費服務費率",
    _choose: "選擇",
    _backup_when_clean: "清機時是否強制資料備份",
    _kitchen_order_dishes_language: "廚房單菜式語言",
    _kitchen_order_use_only: "僅廚房單使用",
    _current_order_language: "當前點餐語言",
    _inv_header: "發票頭備註",
    _inv_footer: "發票尾備註",
    _proan_inside: "保雅內部使用",
    _android_user_interface_setup: "Android用護界面設置",
    _table_no_ppl: "檯號/人數",
    _print_modifiers_additional_charges: "特別處理加價時是否列印",
    _print_free_modifiers: "特別處理不加價時是否列印",
    _inv_print_0_amt_item: "金額為零的項目是否列印",
    _print_set_meal_details: "是否列印套餐細節",
    _print_user_and_time_on_invoice: "發票項目是否列印落單人及時間",
    _payway_rate_tip: "設置在生效日期之後, 當前貨幣可兌換的現金, 如 cash/美元 = 10/1,即1美元等價於10元現金",
    _current_currency: "當前貨幣",
    _discper: "折扣百分比 (%)",
    _modifier_multiple_qty_whether_effective: "特別處理乘以數量是否生效",
    _is_active: "是否有效 ",
    _effective: "有效",
    _bottom: "最後一行",
    _next: "下一行",
    _prev: "上一行",
    _top: "第一行",
    _address_setup: "地址設置",
    _address_list: "地址列表",
    _area_code: "區域編碼",
    _area_setup: "區域編號設置",
    _subarea_setup: "分區設置",
    _hold: "等叫起",
    _clean_input_tips: "清機是否提示輸入提示",
    _paylist_print_itemcode: "埋腳紙是否列印菜式編號",
    _period1: "時段1",
    _period2: "時段2",
    _period3: "時段3",
    _order_by: "排序",
    _opening_section: "營業時段",
    _svc_charge: "服務費",
    _order_only: "點菜",
    _whether_to_continue: "是否繼續",
    _deshes_level: "菜式級別",
    _setting_general: "一般設定",
    _print_on_order_list: "是否列印上菜紙",
    _set_background_image: "設置背景圖片",
    _please: "選擇",
    _selected: "選中",
    _page_information_management: "頁面信息管理",
    _page_maintenance: "頁面維護",
    _slip_print_mode_void_item: "取消菜式時上菜紙列印方式",
    _complete_all_reprint: "完成後全部重新列印",
    _phase: "期",
    _tower: "座",
    _floor: "樓",
    _room: "室",
    _login_account: "登錄帳號",
    _alphanumeric_underline_input_only: "只能輸入字母數字下劃線",
    _buildin_data_no_edit: "系統預設數據,不可修改",
    _historical_records: "歷史記錄",
    _shop_qty: "分店數量",
    _sales_analysis: "銷售分析",
    _select_addr: "請選擇地址",
    _item_warning_mode: "庫存警告方式",
    _not_prompt: "不提示",
    _always_prompt: "永遠提示",
    _set_by_item: "按菜式設定",
    _qty_not_enough_continue: "庫存數量不足,是否繼續售賣 ?",
    _item_warning_qty: "庫存不足是否提示",
    _allow_add_price_for_item_discount: "套餐菜式加價是否允許項目折扣",
    _no_sales_item: "包括沒有銷售的菜色",
    _catery_dishes: "種類+菜色",
    _dept_dishes: "部門+菜色",
    _waiter_dept: "服務員+部門",
    _group_by: "組合",
    _show_cost: "顯示成本",
    _show_daily: "顯示每日",
    _invalid_invcode: "輸入條碼格式不正確, 請重新輸入 !",
    _barcode_wrong: "沒有此號碼的單據!",
    _order_done: "訂單已刪除!",
    _order_paid: "訂單已結賬",
    _discount_round: "折扣+微調",
    _profit: "毛利",
    _margin: "毛利率",
    _pages: "頁數",
    _belongdate: "所屬日期",
    _docno: "文件編號",
    _stock_take_option: "盤點選擇",
    _part: "部分",
    _variance: "相差數量",
    _takeqty: "盤點數量",
    _aggregate: "累計",
    _sales_analysis_section: "銷售分析-時段",
    _show_amt_type: "顯示金額",
    _daily_sales: "每日營業額",
    _show_days_without_data: "顯示沒有記錄的日期",
    _show_rounding: "顯示微調",
    _avginv: "每單",
    _department_daily_report: "部門按日統計報表",
    _cost_percentage: "成本百分比",
    _committed_cannot_edit: "不允許修改已審核的文件。",
    _delete_cannot_edit: "不允許修改已刪除的文件.",
    _sto_belongdate: "盤點日期",
    _onhand: "現有數量",
    _variance_cost: "相差數量成本",
    _cmd_stocktake: "盤點",
    _seq_no: "序號",
    _Atte_Cut_time: "考勤截止時間",
    _attendance_cam: "是否有攝像頭",
    _attendance_range_count: "考勤截止時間段",
    _function_introduction: "功能簡介",
    _dishes_composition_setting: "菜式成分設定",
    _picture: "圖",
    _caption: "說明",
    _please_select_department: "請選擇菜式所屬部門",
    _signinout: "上下班",
    _period: "時間段",
    _sign_in: "上班簽到",
    _sign_out: "下班簽到",
    _whether_to_clean_up_qty_every_day: "是否每天清理數量",
    _not_commit_no: "還有盤點單未經審核，編號是：",
    _detail: "詳細",
    _display: "顯示",
    _summary: "精簡",
    _income_analysis: "收入+分析",
    _unclassified: "未分類",
    _item_qty_per_day: "菜色每日數量",
    _best_worst_selling: "最佳/最差銷售",
    _rank: "名次",
    _hour: "小時",
    _daily_and_hour: "每日+小時",
    _update_modifier_qty_match_item_qty_changes: "更改數量時特別處理是否相應更改(特別處理乘以數量下不生效)",
    _checkout_time: "結賬時間",
    _best: "最佳",
    _worst: "最差",
    _count: "數量",
    _money: "金額",
    _species_group_show: "種類分組顯示",
    _show_deleted: "顯示已刪除資料",
    _copy_from_other_shop: "從其他分店複制",
    _number: "次數",
    _picture_maintenance: "圖片維護",
    _subcate_dishes: "子類+菜色",
    _brand_dishes: "品牌+菜色",
    _vendor_dishes: "供應商+菜色",
    _change_item_price: "更改項目單價",
    _inv_no: "發票號碼",
    _table_useage_analysis: "餐檯使用分析",
    _group_show: "分組顯示",
    _by: "按",
    _sign: "上下班",
    _pay_off_line: "離線買單",
    _member_no: "會員編號",
    _member_name: "會員名稱",
    _member_tel: "會員電話",
    _point_rule: "積分規則",
    _member_maintenance: "會員維護",
    _table_section_analysis: "餐檯時段分析",
    _modifier_report: "特別處理報表",
    _paid_in: "實收",
    _discount_percentage: "折扣百分比",
    _special_discount_percentage: "特價折扣百分比",
    _calc_method: "計算方法",
    _discount_report: "折扣報表",
    _mail_addr: "郵寄地址",
    _eng_name: "英文名稱",
    _chi_name: "中文名稱",
    _mobile_phone: "手提電話",
    _homepage: "網址",
    _job: "職業",
    _id_no: "身份證號碼",
    _birthday: "出生日期",
    _join_shop: "加入店鋪",
    _inv_count: "消費次數",
    _current_points: "現有積分",
    _inv_amount: "消費金額",
    _gender: "性別",
    _residential: "住宅地址",
    _male: "男",
    _female: "女",
    _lbl_yyyymmdd: "(年/月/日)",
    _inv_input_member_show_message_1: "當輸入或取消會員,",
    _inv_input_member_show_message_2: "系統會重新計算每一項目金額",
    _points_to_redeem: "積分兌換",
    _point: "積分",
    _normal_calculation: "正常計算",
    _round_to_2_decimal: "四舍五入到兩位小數位",
    _round_to_1_decimal: "四舍五入到一位小數位",
    _round_to_integer: "四舍五入到整數",
    _up_to_integer: "少計至整數",
    _down_to_integer: "多計至整數",
    _date_last: "結束日期",
    _can_edit_price_now: "是否允許轉價",
    _redeem_to_integer: "是不是要整數換積分",
    _move_item: "項目轉檯",
    _company_name: "公司名稱",
    _show_multi_unit_on_kitchen: "廚房單是否顯示多單位",
    _show_multi_unit_on_slip: "上菜紙是否顯示多單位",
    _show_quick_payment_qr_code: "是否顯示快速付款QR Code",
    _kit_callup: "廚房叫起單",
    _tel_addr: "電話/地址",
    _eng_chi_name: "中/英文名稱",
    _code_or_email: "編號或電郵",
    _qty_range: "數量範圍",
    _payslip_printer: "埋腳紙打印機",
    _already_add: "己加入",
    _already_success: "己加入成功",
    _recipe_already_exist: "材料已存在,不能重復",
    _onhand_qty: "現有數量",
    _take_qty: "盤點數量",
    _approve: "核准",
    _link_man: "聯繫人",
    _voided_items: "刪除項目",
    _unselect: "不選擇",
    _member_list: "會員報表",
    _circle: "圓形",
    _not_to_print: "未列印",
    _register: "註冊",
    _registered: "已註冊",
    _not_registered: "對不起,您尚未註冊系統",
    _sex: "性別",
    _code_name: "編號/名稱",
    current_printer_is_already_in_use: "當前印表機已使用中, 是否繼續",
    "_member/ member_type": "會員/會員類型",
    _no_printer_found: "沒有安裝打印機",
    _show_each_shop: "顯示每間分店",
    _qty_not_enough: "庫存數量不足 !",
    _whether_server: "是否服務器",
    _amount_number: "賬號",
    _whether_talking_caller: "是否語音報號",
    _regular_discount_percentage: "正價折扣百分比",
    _waiting: "等待中",
    _period4: "時段4",
    _period5: "時段5",
    _show_multi_unit_on_invoice: "發票是否顯示多單位",
    _show_multi_unit_on_pay_slip: "埋腳紙是否顯示多單位",
    _item_data: "菜色資料",
    _qty_remain: "庫存數量",
    _item_no_range: "項目編號範圍",
    _sold_out_dishes: "已售罄菜式",
    _not_show_in_order: "點菜時不顯示",
    _do_clean_confirm: "是否確定清機 ??",
    _inv_checked: "清機完畢 !",
    _material_list: "成份列表",
    _vendor_list: "供應商列表",
    _section1: "時段一",
    _section2: "時段二",
    _section3: "時段三",
    _section4: "時段四",
    _section5: "時段五",
    _print_modifier_prices: "特別處理是否列印金額",
    _item_id: "菜式編號",
    _point_used: "使用積分",
    _points_remain: "結余積分",
    _day: "日",
    _month: "月",
    _print_modi_same_line: "特別處理是否打印在同一行",
    _print_item_modi_sale_line: "特別處理是否和菜式列印在同一行",
    _inv_print_void_item: "發票是否列印取消菜式",
    _take_away_address: "外賣地址",
    _set_min_charge: "是否設置最低消費",
    _print_pay_slip_fastfood: "外賣是否列印埋腳紙",
    _sys_user_list: "使用者信息",
    _invoice_print: "堂座是否列印發票",
    _member_group_show: "會員分組統計報表",
    _sitem_print_shell: "套餐是否列印套餐名稱",
    _print_all_after_completion: "完成後全部重新列印",
    _soldout_setup: "菜式售罄訊息設定",
    _service_charge: "服務費率",
    _inv_print_table_name: "發票是否印餐檯名稱",
    _more_to_min_currency_unit: "多收至最小貨幣單位",
    _less_to_min_currency_unit: "少收至最小貨幣單位",
    _round_to_min_currency_unit: "四舍五入至最小貨幣單位",
    _computer_name: "電腦名稱",
    _income: "收入",
    _analysis: "分析",
    _selected_item: "已選擇項目",
    _annual_business_report: "全年营业报表",
    _select_please_: "請選擇{0}",
    _show_modi: "顯示特別處理",
    _effective_outlet: "有效營業區域",
    _month_total: "本月累計",
    _days_total: "日子累積",
    _average_daily: "每日平均",
    _year_total: "本年累計",
    _year_days_accumulate: "本年日子累積",
    _year_average: "本年累積平均",
    _jan: "一月",
    _feb: "二月",
    _mar: "三月",
    _apr: "四月",
    _may: "五月",
    _jun: "六月",
    _jul: "七月",
    _aug: "八月",
    _sep: "九月",
    _oct: "十月",
    _nov: "十一月",
    _dec: "十二月",
    _no_same_outlet: "不同營業區域,是否繼續?",
    _allow_all_price_book: "允許所有價格表",
    _exist_same_addr: "存在相同的地址名字.",
    _allow_all_disc_pricebook: "允許價目表折扣",
    _allow_pricebook: "允許價目表折扣",
    _include_station: "包括工作站",
    _member_sales_analysis: "會員消费分析",
    _pet_age: "年齡",
    _pet_type: "寵物種類",
    _one_year_amount: "一年銷售額",
    _wrist: "手吋",
    _setup_mode: "設定模式",
    _exclude_holiday: "公眾假期除外",
    _sales_price: "銷售價",
    _please_input_name: "請輸入名稱",
    _invoice_descending: "單號(由大至小)",
    _invoice_ascending: "單號(由小至大)",
    _tableno_descending: "檯號(由大至小)",
    _tableno_ascending: "檯號(由小至大)",
    _amount_descending: "金額(由大至小)",
    _amount_ascending: "金額(由小至大)",
    _join_qty_or_spin_off: "點菜合並或分拆處理",
    _not_handling: "不處理",
    _join_qty_when_same_item: "同壹菜式合並至壹行",
    _mult_order_item_break: "點菜數量大於1分拆",
    _can_not_re_add_to_menu: "不能重復添加在餐牌中",
    _schedule_price: "時段售價",
    _price_fastfood: "外賣售價",
    _sale_period: "只在時段內售賣",
    _calc_with_org_srv: "按原價計服務費",
    _project: "計劃",
    _custom_section: "自定義營業時段",
    _tax_setup: "稅項設定",
    _remin_reason_setup: "追單原因設定",
    _reason_for_press_alarm: "客戶按警鍾原因設置",
    _fastfood_message_setup: "外賣信息設定",
    _auto_disc_setup: "自動折扣設定",
    _dine_active: "堂座是否有效",
    _fastfood_active: "快餐是否有效",
    _barcode_active: "倏码是否有效",
    _barcode: "條碼",
    _barcode_check_out: "條碼結帳",
    _order_langue: "點菜界面語言",
    _year_repeat: "每年重復",
    _receipt_remark: "發票備注",
    _charge_type: "餘額處理",
    _change_return: "餘額找回",
    _change_inre: "餘額不找",
    _change_tips: "餘額作小費",
    _currency_ratio: "每單位相當於標準貨幣的倍數",
    _is_input_creditcardno: "是否輸入信用卡號碼",
    _lms_recharge: "會員卡外幣充值",
    _pay_type: "Pax機類型",
    _none: "無",
    _swipe_card: "刷卡",
    _quick_pass: "快速支付",
    _both: "兩者皆是",
    _is_cash_coupon: "是否現金券",
    _cash_coupon_value: "現金券面額",
    _bo_cash_coupon_date_startth: "現金券生效日期",
    _cash_coupon_date_last: "現金券終止日期",
    _print_other_lanaguage: "是否指定打印其它語言(如存在)",
    _auto_backup: "負責系統自動備份",
    _linkserver: "連接服務器",
    _default_language: "預設語言",
    _table_page: "預設餐檯頁數",
    _allow_signinout: "允許上下班打卡",
    _allow_invoice: "允行結帳",
    _has_drawer: "安裝抽屜",
    _port_no: "端口",
    _has_port: "串口抽屜",
    _pole_display: "顧客顯示屏",
    _pole_display_message: "顧客顯示屏訊息",
    _self_order_tableno: "Android自助落單關聯檯號",
    _having_card_reader: "是否有外掛讀卡器",
    _queuing_machine: "叫號機",
    _calc_with_tael: "按兩計算",
    _kit_print_attention: "註意, 上壹張如果打印不完整, 請不要使用",
    _backcolor: "背景顏色",
    _no_check_out_when_zero: "零金額不允許結帳",
    _add_log: "是否添加日誌",
    _free_amount_by_order: "每單可奉送金額",
    _auto_order: "自動進入點菜畫面",
    _auto_lout: "自動登出系統",
    _auto_lout_return_main: "自動登出時回到主界面",
    _no_operate: "秒沒有任何操作,自動登出",
    _info_can_view: "營業資料可檢視",
    _password_card_dbl_check: "密碼和卡號雙重認證",
    _minute: "分鐘",
    _no_print: "不列印",
    _no_print_when_zero: "零金額一定不列印",
    _material_cate: "成份種類",
    _menu_manage: "餐牌管理",
    _item_manage: "菜式管理",
    _item_maintenance: "菜式維護",
    _default_disc: "預設折扣",
    _select_classification: "選擇類別",
    _advanced_administrator: "高級管理員",
    _fastfood: "外賣",
    _askprice: "即問價",
    _sync_order_dine: "同步到保雅自助落單",
    _please_select_at_least_one_item: "請至少選擇一個菜式",
    _please_select_at_least_one_modi_cate: "請至少選擇一個特別處理種類",
    _item_modi_batch: "批量操作菜式特別處理",
    _item_modi_batch_update: "批量更新菜式特別處理",
    _item_modi_batch_add: "批量添加菜式特別處理",
    _item_modi_batch_delete: "批量刪除菜式特別處理",
    _not_add_if_exist: "存在不新增",
    _only_add: "僅新增",
    _if_exist_the_same_modi_cate_not_add: "如果存在相同特別處理, 則不新增",
    _if_exist_the_same_modi_cate_replace_must_item_and_add_corresponding_quantity: "如果存在相同特別處理, 則替換''是否必須''項，在原有數量上增加相應數量",
    _item_printer_batch: "批量操作列印設定",
    _item_printer_batch_update: "批量更新列印設定",
    _item_printer_batch_add: "批量添加列印設定",
    _item_printer_batch_delete: "批量刪除列印設定",
    _please_select_at_least_one_printer: "請至少選擇一個印表機",
    _category: "種類",
    _categories: "分類",
    _item_rule: "菜式規則",
    _original_price: "原價",
    _original_price_fastfood: "外賣原價",
    _copy_color_to_items_with_same_category: "把顏色拷貝至同一種類",
    _if_exist_the_same_modi_cate_replace_must_item: "如果存在相同特別處理, 則替換''是否必須''項",
    _auto_logout: "自動登出系統",
    _auto_logout_return_main: "自動登出時回到主界面",
    _show_password: "顯示密碼",
    _levelA: "級別A",
    _levelB: "級別B",
    _disc_sys_user_can_not_more_than: "生效用戶不能超過{0}個",
    _disc_sys_user_more_than_size: "生效用戶超過長度",
    _sure_to_add_all_entry: "確定要加入全部項目嗎",
    _not_allow_more_than_char: "不允許超過{0}個字符",
    _current_printer_is_already_in_use: "當前印表機已使用中, 是否繼續",
    _item_code_or_barcode_exist_not_repeat: "菜式編號或條碼已存在,不允許重複",
    _selforder_item_modi: "自助落單菜式處理",
    _shop_count: "分店數量",
    _can_select: "可選擇",
    _term: "項",
    _can_repeat_select: "可重複選擇",
    _order_interface_info: "點菜界面簡介",
    _item_info: "菜式信息",
    _repeat_not_allow_recall: "重複不允許恢復",
    _cut_order_min: "截單時間",
    _sit_in_min: "總時間",
    _item_cut_order: "截單時間設置",
    _cut_order_min_can_not_longer_than_sit_in_min: "截單時間不能大於總時間",
    _active_section_apply_to_active_dishes_cate: "生效時段應用到生效菜式種類中",
    _not_allow_delete: "不允許刪除",
    _upgrade_item: "升級餐菜式",
    _belong_to_item_list: "所屬升級餐菜式",
    _not_sync_order: "不同步到保雅自助落單",
    _station_apply_to_active_dishes_cate: "工作站應用到生效菜式種類中",
    _station_apply_to_system_setting: "工作站應用到系統設定中",
    _percent: "百分比(%)",
    _please_set_price_first: "請先設置銷售價",
    _so_disc: "自助下單堂座折扣",
    _so_disc_amt: "自助下單堂座折扣金額",
    _so_disc_perc: "自助下單堂座折扣百分比",
    _so_disc1: "自助下單外賣折扣",
    _so_disc_amt1: "自助下單外賣折扣金額",
    _so_disc_perc1: "自助下單外賣折扣百分比",
    _so_print_slip: "自助下單是否打印上菜紙",
    _so_printer: "自助下單上菜紙打印機",
    _total_price_of_all_departments_must_equal_to_price: "各部門相加必須等於售價",
    _whether_add_to_menu: "是否要加入到餐牌？",
    _whether_pop_join_menu_next_time: "下次是否提示加入到餐牌",
    _join_menu: "加入餐牌",
    _multi_item_must_include_an_item: "多選菜式必須包含一個菜式",
    _inventory_management: "存貨管理",
    _stock_report: "存貨報表",
    _stock: "存貨資料",
    _allow_sell: "是否允許售賣",
    _not_allow: "不允許",
    _advanced: "高級",
    _tot_cost: "共成本",
    _compose_type: "組合類型",
    _and: "及",
    _custom_goods: "自定貨品",
    _custom_price: "自定售價",
    _custom_fastfood_price: "自定外賣價",
    _copy_to_fastfood_price_from_price: "從銷售價複製到外賣售價",
    _upgrade_multi_qty: "升級餐允許多次落單",
    _po_packing_fee_add: "額外餐盒費（外送）",
    _po_plastic_bag_fee_add: "額外膠袋費（外送）",
    _pot_packing_fee_add: "額外餐盒費（自取）",
    _pot_plastic_bag_fee_add: "額外膠袋費（自取）",
    _po_delivery_fee_add: "額外配送費（外送）",
    _single_po_plastic_bag_fee: "單個膠袋收費(外送)",
    _single_pot_plastic_bag_fee: "單個膠袋收費(自取)",
    _po_plastic_bag_fee_add_perc: "占單個膠袋空間(%)(外送)",
    _pot_plastic_bag_fee_add_perc: "占單個膠袋空間(%)(自取)",
    _category_dishes: "種類+菜色",
    _sales_report: "銷售報表",
    _brow_level_item_in: "查看菜式級別({0})的菜式",
    _no_ask_remark: "不問備註",
    _must_input_remark: "必須輸入備註",
    _ask_remark_can_empty: "問備註，但可允許不輸入",
    _whether_ask_remark: "是否問備註",
    _so_qr_order_count: "堂座自動落單每次落單數量上限",
    _so_tables_count_plus_ppl: "堂座總落單數量上限",
    _limit_when_click: "點擊時限制",
    _check_when_submit: "提交時檢查",
    _total_quantity_may_exceed_the_limit_quantity: "總數量有機會超出限制數量，客戶不清楚有數量限制",
    _price_limit_prompt_a_quantity_limit_for_dishes: "嚴格限制，會明確提示用戶菜式有數量限制",
    _extra_pointrate: "額外積分倍數",
    _extra_pointfix: "額外固定積分",
    _points_needed: "所需積分",
    _timing: "計時",
    _is_timer_item: "是否計時菜式",
    _calculated_from_seating_time: "按入座時間開始計算",
    _according_to_adding_dishes_time: "按菜式加入的時間開始計算",
    _how_many_minutes_a_section: "多少分鐘一段",
    _timer_level_price: "前{0}個時段價",
    _wechat_pay: "微信支付",
    _alipay: "支付寶",
    _uepay: "極易付錢包",
    _china: "中國",
    _hk: "香港",
    _use_previous_section_price_plus_sell_price_if_zero_for_section_price: "時段價填0，會使用上一時段計算價+售價",
    _price_of_first_X_period_cannot_be_all_zero: "前X時段價不能全為零",
    _add_one: "加一個",
    _minus_one: "減一個",
    _tip: "小費",
    _paymethod: "付款方法",
    _simplify: "精簡",
    _daily_turnover: "每日營業額",
    _inv_no_range: "發票編號範圍",
    _seat_time: "入座時間",
    _inv: "發票",
    _disc: "折扣",
    _include_srv: "包含服務費",
    _display_modi: "顯示特別處理",
    _date_cannot_cross_month: "日期不能跨月份",
    _date_not_found: "對不起！未找到數據",
    _dish_daily_quantity: "菜式每日數量",
    _category_pay_excel: "種類+付款(Excel)",
    _show_each_item: "顯示每個菜式",
    _report_date_not_allow_more_than_day: "報表日期不允許超過{0}天",
    _services: "服務",
    _sun: "日",
    _mon: "一",
    _tue: "二",
    _wed: "三",
    _thu: "四",
    _fri: "五",
    _sat: "六",
    _rev_sales_byday: "按日檢視銷售",
    _Self_help: "自助",
    _Customs: "自定",
    _Custom_Business_Hours: "自定+營業時間",
    _Business_Hours: "營業時間",
    _self_hours_areas: "自助有效營業時段",
    _Only_QrCode_orders: "只適用於QrCode落單",
    _Sales_induction_department: "銷售額歸納到部門",
    _default_cup: "茶芥",
    _General_settings: "一般設定",
    _srv_tran: "時段服務費",
    _calc_type: "計算模式",
    _Calculated_dishe: "以加入菜式時間計算",
    _Calculated_seat: "以入座時間計算",
    _srv_name: "轉向服務費",
    _start_date: "開始日期",
    _end_date: "結束日期",
    _srv_tran_start_time: "每日起始時間",
    _srv_tran_end_time: "每日終止時間",
    _turn: "轉向",
    _srv_tran_empty: "轉向服務費不能為空",
    _ex_festival: "節假日除外",
    _srv_tran_sort: "升序或降序至少2行數據",
    _srv_tran_sort_save_tip: "當前選中行數據未保存,請選擇其他行再排序",
    _linkserver_backup: "負責落單數據備份",
    _pole_display_silver: "銀碼顯示器",
    _pole_message_silver: "銀碼顯示器信息",
    _unit_swap: "單位對換數",
    _Invoice_cn: "發票(中文名稱)",
    _Invoice_en: "發票(英文名稱)",
    _Is_it_allow: "是否允許",
    _required_item_check: "必須項目(於印單時檢查)",
    _order_interface_info_cn: "中文點菜界面簡介(自助點餐)",
    _item_info_self_cn: "中文菜式信息(自助點餐)",
    _order_interface_info_en: "英文點菜界面簡介(自助點餐)",
    _item_info_self_en: "英文菜式信息(自助點餐)",
    _ask_dept: "即問分帳",
    _modi_dept_after_inv: "結帳後修改分帳",
    _print_kit: "列印廚房單",
    _total_customer: "總顧客",
    _total_invoice_quantity: "總單數",
    _amount_per_guest: "平均每人",
    _amount_per_order: "平均每單",
    _dine_in_amount: "堂座金額",
    _dine_in_inv_qty: "堂座單數",
    _five_best_selling: "五大好賣",
    _total_sales_amount: "銷售總金額",
    _operation_log: "操作日志",
    _already_printed: "已印單",
    _no_printed: "未印單",
    _comparison_report_section: "比較報表-時段",
    _outlet_amount: "營業區域營業額",
    _discount_name: "折扣名稱",
    _calc_mode: "計算模式",
    _meal_time: "用餐時間",
    _common_timing: "普通計時",
    _each_time_add: "單項加鐘",
    _time_related_ppl: "與人數相關的加鐘",
    _display_in_selforder: "保雅自助落單顯示",
    _print_order_slip: "列印上菜紙",
    _print_pay_list: "列印付款清單",
    _menu_options: "菜單選項",
    _add_type: "追加方式",
    _unlimit_qty: "不限追加數量",
    _total_qty: "所有子項追加數量",
    _each_item_qty: "每個子項追加數量",
    _add_total_qty: "追加總數量",
    _add_qty: "追加數量",
    _add_qty_upper: "追加上限",
    _include_item: "包含菜式",
    _each_item_qty_not_zero: "每個子項追加數量，數量不能為零	",
    _method: "方法",
    _add_qty_upper_zero_info: "追加上限不填寫將不限制",
    _disc_mm: "mm",
    _distribute_item: "已分配項目",
    _self_order_remark: "自助落單備注",
    _deleted: "已刪除",
    _so_qr_order_count_ppl: "是否乘人數",
    _so_tables_count_plus_ppl_everyone: "堂座自助總落單數量上限(每人)",
    _show_sitem_name: "顯示套餐名稱",
    _section_price_cate_cannot_empty: "時段售價適用菜式種類不能為空",
    _edit_custom_section_shall_prevail: "全部分店時如果修改了自定義時段後, 以時段為准",
    _sync_foodpanda: "同步到foodpanda",
    _unid_cost: "單位成本",
    _incorrect_shop_price_section: "時段售價設置有誤: 全部分店設置在時段內售賣時, 要修改自定義時間",
    _applicable_cate: "適用菜式種類",
    _same_cost_as_dishes: "跟菜式成本",
    _custom_cost: "自定義成本",
    _foodpanda_add_rate: "Foodpanda 加價比率",
    _foodpanda_add_rounding: "Foodpanda 加價零頭處理",
    _foodpanda_add_rounding1: "少收至元",
    _foodpanda_add_rounding2: "小收至毫",
    _allow_kb_ord: "點菜鍵盤搜索時允許",
    _sales_category: "銷售種類",
    _must_modi_select_all: "必選特別處理時，全部選擇",
    _classification: "類別",
    _channel: "通道",
    _so_tables_count_plus_ppl_active: "乘人數",
    _effective_section_detail: "生效營業時段詳情",
    _schedule_price_plan_detail: "時段售價計劃詳情",
    _schedule_price_shop_detail: "時段售價分店詳情",
    _cost_type: "跟菜式成本/自定義成本",
    _void_user: "落單人",
    _net_amt: "付款",
    _void_user_title: "用戶",
    _enter_mode: "進入模式",
    _ask_dept_confirm: "啟用即問部門分賬將不可能對此菜式進行折扣,是否繼續?",
    _modi_dept_after_inv_confirm: "啟用結賬後修改分賬將不可能對此菜式進行折扣,是否繼續?",
    _operation_record: "操作記錄",
    _accident_record: "事故記錄",
    _octopus_record: "八達通記錄",
    _change_price_record: "更改價格記錄",
    _turntable_record: "轉檯記錄",
    _goods_exchange_record: "貨品交換記錄",
    _worst_selling: "最差銷售",
    _best_sales: "最佳銷售",
    _worst_selling_amount: "最差銷售金額",
    _worst_selling_quantity: "最差銷售數量",
    _best_sales_amount: "最佳銷售金額",
    _best_sales_quantity: "最佳銷售數量",
    _comparison_type: "比較類型",
    _turnover_during_business_hours: "營業時段營業額",
    _wechat_report: "微信報表",
    _departmental_turnover: "部門營業額比例圖",
    _qrcode_remind_mins: "自助落單超過多少分鐘追單",
    _qrcode_remind_mins_tip: "0代表不追單",
    _shop_tableno_tip: "分店與檯號不能為空!",
    _show_in_cup_mode: "在茶芥頁面上改數量",
    _focus_item: "重點關注菜式",
    _by_entity_for_calc_qty: "按整條計算數量(報表和售罄)",
    _include_all_cate: "（* =包括所有種類）",
    _festival: "節假日",
    _exclude_festival: "節假日除外",
    _set_sub_item_sold_out: "套餐子項是否計算菜式售罄餘數",
    _dine_in_detail: "堂座詳情",
    _order_invoice_list: "發票列表",
    _local_print_kit: "本機列印廚房單",
    _qr_android_local_kit_printer_id: "廚房單打印機(Qrcode, Android本地打印菜式適用)",
    _dine_in: "堂座",
    _restaurant_turnover: "餐檯營業額(災備)",
    _is_itemdept: "是否參與分賬",
    _departments_price_can_not_zero: "菜式部門價格不能為零",
    _view_user_password: "查看用戶密碼",
    _proan_wechat_user: "微信授權關聯用戶",
    _user_code: "用戶標識碼",
    _own_role: "所屬角色",
    _deleted_user: "原綁定用戶已刪除",
    _user_instructions: "用戶標識碼獲取說明",
    _attention_public: "掃碼關注微信公眾號",
    _click_setting_center: "进入我们的微信公众号,点击【设置中心】",
    _see_personal_information: "進入設置中心頁面,即可看到個人信息下方的用戶標識碼",
    _no_matches_found: "未找到匹配項",
    _only_digits: "只能為{0}位數字",
    _max_effective_users: "最大生效用戶數量",
    _number_remaining_users: "剩餘可加用戶數量",
    _due_date_wechat_Report: "wechat報表到期日",
    _lookup_shop_list: "包括分店、分店群組、不包括分店至少選擇一個",
    _maximum_number_valid_users_exceeded: "已超過最大有效用戶數量",
    _calc_time_by: "按當前時間",
    _calc_time_by_current: "按當前時間",
    _calc_time_by_seat: "按入座時間",
    _input_maxlength: "輸入長度不能超過{0}個字符",
    _new_start_time: "每天的開始時間",
    _new_end_time: "每天的結束時間",
    _calc_time_by_title: "顯示方式",
    _wechat_sys_user_row: "提示：目前顯示{0}條用戶數據,可使用搜索功能",
    _end_date_to: "日期至",
    _start_date_to: "日期由",
    _date_from_new: "日期由",
    _date_to_new: "日期至",
    _visitor_analysis: "來客分析報告",
    _daily_avg_report: "每日人均報表",
    _add_time: "上傳時間",
    _shop_tip: "分店不能為空!",
    _attendance_report: "考勤報表",
    _employee_date: "員工+日期",
    _date_employee: "日期+員工",
    _show_user_id: "顯示使用者編號",
    _work_hours: "工作時數",
    _multi_choise_for_proan: "至多選擇",
    _must_choise_for_proan: "必選特別處理時生效",
    _min_choise_for_proan: "至少選擇",
    _print_limit: "必須選擇一個台號,才允許打印",
    _print_all_tip: "當前無打印數據",
    _print_search_tip: "提示:檯號非必填項",
    _print_all_report: "全部打印",
    _print_report: "打印",
    _must_select_modi: "必選特別處理時,必選擇",
    _case_mat_multiple: "例",
    _case_mat: "席",
    _case_mat_tip: "(為0則不是例/席)",
    _color_desc: "顏色說明",
    _blank_table: "空白檯",
    _ever_printed: "曾印單",
    _other: "其他",
    _qr_min_order_qty: "自動點餐菜式最低點菜數量",
    _is_cashier: "收銀員",
    _monthly_turnover: "每月營業額",
    _system_name: '公司系統',
    _switch_language: '切换语言成功',
    _theme_switching: "主題切換",
    _full_screen: "全屏",
    _language_label:"語言",
    _account:"賬號",
    _login_title: "保雅电脑餐飲後臺管理系統",
    _input_code: "請輸入編碼",
    _input_name: "請輸入名稱",
    _cancel_dekete: "已取消删除",
    _shop_new: "分店[新增]",
    _shop_edit: "分店[修改]",
    _select_please_input: "---請選擇---",
    _saveing: "保存中..",
    _select_please_section: "請選擇時段",
    _empty_Tips: "必填資訊填寫不完整，請檢查！",
    _font_size: "字體大小",
    _switch_size: '切換字體大小成功',
    _small: "小",
    _medium: "中",
    _big: "大",
    _input_account: "請輸入賬號",
    _input_password: "請輸入密碼",
    _logining: "登錄中..",
    _station_new: "工作站[新增]",
    _station_edit: "工作站[修改]",
    _input_station_name: "請輸入工作站名稱",
    _select_shop: "請選擇分店",
    _back_top: "返回頂部",
    _back_bottom:"返回底部",
};
export default zh_tw;
